import { getSeoUrl } from 'utils/links';
import {
  CATEGORY_URL,
  CVA_DEFAULT_LOCALE,
  CVA_GENERAL_SUPPORTED_LANGUAGES,
  CVA_LEARN_MORE_GENERAL_URL,
  CVA_LEARN_MORE_SPECIFIC_URL,
  CVA_SPECIFIC_SUPPORTED_LANGUAGES
} from './[part-name]/[part-number]/constants/constants';
import {
  IS_CUSTOMER_SUPPORT_ENABLE,
  PCC_HEADLESS_ASSETLANDINGPAGE,
  PCC_HEADLESS_BLOCKS_CATEGORY_PAGE,
  PCC_HEADLESS_BLOCKS_PDP_TOP_SECTION,
  PCC_PLP_VIEW_SPECS_DRAWER,
  PCC_SEARCH_RESULTS_SPECIFICATIONS_DRAWER,
  PCC_UPDATE_PDPCTA_TO_SEA_PARTS
} from 'constants/featureFlag';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';

export const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    window.scrollBy({ top: -250, behavior: 'smooth' });
  }
};

export const getFilteredCategories = (categories, alpNonRelatedCategories) => {
  return categories.filter(
    (part) => !alpNonRelatedCategories.includes(part.identifier)
  );
};

export const getCategoryPageUrl = (
  url: string,
  isHeadlessCategoryPage: boolean,
  params
) => {
  const categoryUrl = isHeadlessCategoryPage
    ? `/${CATEGORY_URL}/${url}`
    : `/${url}`;
  return getSeoUrl(params, categoryUrl);
};

export const getMaintenceRepairList = (
  pmkitData,
  SSROData,
  MAINTENANCE_REPAIR_LIMIT = 5
) => {
  let combinedKits = pmkitData.sort((a, b) => (b.isCatKit ? 1 : -1));
  if (combinedKits.length < MAINTENANCE_REPAIR_LIMIT) {
    combinedKits = [...combinedKits, ...SSROData];
  }
  return combinedKits.length > 0
    ? combinedKits.slice(
        0,
        Math.min(combinedKits.length, MAINTENANCE_REPAIR_LIMIT)
      )
    : [];
};

export const getPMKitsData = (pmKitsList) => {
  const catKitList = [];
  const dealerKitList = [];
  for (const pmKitsItem of pmKitsList) {
    if (pmKitsItem.isCatKit) {
      catKitList.push(pmKitsItem);
    } else {
      dealerKitList.push(pmKitsItem);
    }
  }
  return { catKitList, dealerKitList };
};

export const getFeatureFlage = (storefeatures) => {
  return {
    isPCCAssetLandingPageFlagEnabled:
      storefeatures?.[PCC_HEADLESS_ASSETLANDINGPAGE] ?? false,
    isPCCCategoryHeadlessPageEnabled:
      storefeatures?.[PCC_HEADLESS_BLOCKS_CATEGORY_PAGE] ?? false,
    isHeadlessPDPEnabled:
      storefeatures?.[PCC_HEADLESS_BLOCKS_PDP_TOP_SECTION] ?? false,
    isPCCUpdatePDPCTAToSeaPartsEnabled:
      storefeatures?.[PCC_UPDATE_PDPCTA_TO_SEA_PARTS] ?? false,
    pccSearchResultsSpecificationsDrawer:
      storefeatures?.[PCC_SEARCH_RESULTS_SPECIFICATIONS_DRAWER] ?? false,
    pccPLPViewSpecsDrawer: storefeatures?.[PCC_PLP_VIEW_SPECS_DRAWER] ?? false,
    isCustomerSupportEnabled:
      storefeatures?.[IS_CUSTOMER_SUPPORT_ENABLE] ?? false
  };
};

export const cvaGetLink = (locale: string): string => {
  if (CVA_GENERAL_SUPPORTED_LANGUAGES.includes(locale)) {
    return replaceTokensInString(CVA_LEARN_MORE_GENERAL_URL, locale);
  } else if (CVA_SPECIFIC_SUPPORTED_LANGUAGES.includes(locale)) {
    return replaceTokensInString(CVA_LEARN_MORE_SPECIFIC_URL, locale);
  } else {
    return replaceTokensInString(
      CVA_LEARN_MORE_GENERAL_URL,
      CVA_DEFAULT_LOCALE
    );
  }
};
